import { Platform } from '@angular/cdk/platform';
import { CommonModule } from '@angular/common';
import { Component, inject, OnInit, signal } from '@angular/core';
import { StoryContainerComponent } from '@storyteller/container';

import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { AuiBadgeComponent } from '@ral/ui:aui/badge';

// feature component
@Component({
    selector: 'story-navigation',
    template: `
        <nav
            [class.menu--open]="open()"
            class="nav sticky left-0 right-0 top-0 z-10 z-20 min-h-5 bg-info text-surface-background transition-all lg:min-h-0 lg:min-h-10"
        >
            <story-container space="py-0" [skipTopPadding]="true" [skipSmallScreenTopPadding]="true">
                <div class="flex min-h-12 items-center justify-between gap-4 lg:min-h-[104px]">
                    <div>
                        <ng-content select="[navigationLogo]"></ng-content>
                    </div>

                    <div class="flex flex-row gap-6">
                        <div class="flex flex-row items-center gap-2 lg:gap-4">
                            <a href="mailto:automation@antonyco.com">
                                <div class="hidden items-center min-[560px]:flex">
                                    <aui-badge
                                        label="automation@antonyco.com"
                                        icon="envelope"
                                        buttonStyle="solid"
                                        color="primary"
                                    />
                                </div>
                                <div class="flex items-center min-[560px]:hidden">
                                    <aui-badge icon="envelope" buttonStyle="solid" color="primary" />
                                </div>
                            </a>

                            <a href="tel:+420733348555">
                                <div class="hidden items-center min-[560px]:flex">
                                    <aui-badge label="733 348 555" icon="phone" buttonStyle="solid" color="primary" />
                                </div>
                                <div class="flex items-center min-[560px]:hidden">
                                    <aui-badge icon="phone" buttonStyle="solid" color="primary" />
                                </div>
                            </a>
                        </div>
                        <div
                            class="transition-discrete absolute bottom-0 left-0 right-0 top-0 -z-10 hidden h-screen w-full bg-info transition-all lg:relative lg:z-0 lg:block lg:h-auto lg:w-auto lg:bg-transparent lg:p-0 lg:pt-0"
                            [class.!block]="open()"
                        >
                            <ul
                                class="flex h-[70%] flex-col items-center justify-around gap-6 pt-32 lg:h-auto lg:flex-row lg:justify-end lg:gap-8 lg:p-0"
                            >
                                <ng-content></ng-content>
                                <li class="absolute right-5 top-0 ml-4 pb-5 pt-5 lg:relative lg:right-0"></li>
                            </ul>
                        </div>

                        <div class="flex-none lg:hidden">
                            <div class="hamburger pointer relative h-[29px] w-5 p-0" (click)="toggleMenu()">
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                            </div>
                        </div>
                    </div>
                </div>
            </story-container>
        </nav>
    `,
    imports: [CommonModule, StoryContainerComponent, AuiBadgeComponent],
})
export class StoryNavigationComponent implements OnInit {
    open = signal<boolean>(false);
    router = inject(Router);
    route = inject(ActivatedRoute);
    platform = inject(Platform);

    toggleMenu() {
        this.open.set(!this.open());
        if (this.platform.isBrowser) {
            if (this.open()) {
                document.body.style.overflow = 'hidden';
            } else {
                document.body.style.overflow = 'auto';
            }
        }
    }

    ngOnInit(): void {
        this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event) => {
            if (this.platform.isBrowser) {
                document.body.style.overflow = 'auto';
            }
            this.open.set(false);
        });
    }
}
